import React, { Component } from 'react';
import {
  withStyles, CssBaseline, Button, ButtonGroup, Paper,
  Grid, Select, MenuItem, FormControl, Typography, InputLabel, Switch,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TemplateEditForm from '../components/TemplateEditForm';
import TaskTemplate from '../components/TaskTemplate';

import { BLOCK_TYPES } from '../utils/constants';
import Drawer from '../components/Drawer';
import Actions from '../actions';

import Dialog from '../components/Dialog/DialogBox';

const AntSwitch = withStyles((theme) => {
  return {
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  };
})(Switch);

const styles = (theme) => {
  return {
    root: {
      display: 'flex',
      width: '100%',
      marginTop: theme.spacing(1),
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    page_nav: {
      margin: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    filters: {
      display: 'flex',
      justifyContent: 'space-evenly',
      width: '100%',
    },
    innerdiv: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(2),
    },
    filterdiv: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    createform: {
      width: '100%',
    },
    blankTemplate: {
      textAlign: 'left',
      background: '#684f6c',
      opacity: 0.4,
      height: '100%',
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      justifySelf: 'stretch',
      '&:hover': {
        opacity: 1.0,
        cursor: 'pointer',
      },
    },
  };
};

const PAGE_SIZE = 8;
const PAGE = 0;

class TaskTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: PAGE_SIZE,
      page: PAGE,
      block: '',
      filtered: false,
      newTemplate: false,
      openDialog: false,
      _id: '',
    };
  }

  componentDidMount() {
    this.props.getPracticeExercises();
    this.props.getLearnExercises();
    this.props.getQuizes();
    this.props.getAssessments();
    this.props.fetchTaskTemplatePages({ pageSize: PAGE_SIZE, page: PAGE });
    this.props.getVideoTypeExercises();
    this.props.getVideoUrlTypeExercises();
  }

  setAdding=() => {
    this.setState((prevState) => {
      return { newTemplate: !prevState.newTemplate };
    });
  }

  updateTaskTemplate=(data) => {
    this.props.editTaskTemplate(data).then(() => {
      this.props.fetchTaskTemplatePages({ pageSize: this.state.pageSize, page: this.state.page });
    })
      .then(() => {
        alert(`Template updated Successfully!! \n Data: ${JSON.stringify(data)}`);
      });
  }

  createTaskTemplate=(data) => {
    this.props.addTaskTemplate(data).then(() => {
      this.props.fetchTaskTemplatePages({ pageSize: this.state.pageSize, page: this.state.page });
    })
      .then(() => {
        alert(`Template Created Successfully!! \n Data: ${JSON.stringify(data)}`);
      });
  }

  setOpenDialog = (_id) => {
    this.setState((prevState) => { return { ...prevState, openDialog: true, _id }; });
  };

  closeOpenDialog = () => {
    this.setState((prevState) => { return { ...prevState, openDialog: false, _id: '' }; });
  };

  deleteConfirm = () => {
    this.props.deleteTaskTemplate({ _id: this.state._id })
      .then(() => {
        this.closeOpenDialog();
        alert('Template deleted Successfully!!');
        this.props.fetchTaskTemplatePages({ pageSize: this.state.pageSize, page: this.state.page });
      });
  };

  getallTemplatesUi=() => {
    const {
      learnExercises, practiceExercises, quizes, assessments, videoTypeExercises, videoUrlTypeExercises,
    } = this.props;
    const { classes } = this.props;
    return this.props.templates ? (
      <>
        <Dialog open={this.state.openDialog} title="Delete template" onClose={this.closeOpenDialog} confirm={this.deleteConfirm}>
          <p>Are you sure want to delete this template?</p>
        </Dialog>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={3}>
            <div className={classes.createform}>
              {this.state.newTemplate
                ? (
                  <TemplateEditForm
                    creating
                    learnExercises={learnExercises}
                    videoTypeExercises={videoTypeExercises}
                    videoUrlTypeExercises={videoUrlTypeExercises}
                    practiceExercises={practiceExercises}
                    quizes={quizes}
                    assessments={assessments}
                    setformOpen={this.setAdding}
                    createData={(data) => { return this.createTaskTemplate(data); }}
                  />
                ) : null}
            </div>
            {this.props.templates.taskTemplates.map((template) => {
              return (
                <TaskTemplate
                  key={template._id}
                  template={template}
                  learnExercises={learnExercises}
                  videoTypeExercises={videoTypeExercises}
                  videoUrlTypeExercises={videoUrlTypeExercises}
                  practiceExercises={practiceExercises}
                  quizes={quizes}
                  assessments={assessments}
                  updateTaskTemplate={(data) => { return this.updateTaskTemplate(data); }}
                  setOpenDialog={(_id) => { return this.setOpenDialog(_id); }}
                />
              );
            })}
            {this.props.templates.taskTemplates?.length > 0
              ? (
                <Grid item xs={4} onClick={() => { this.setAdding(); }}>
                  <Paper className={classes.blankTemplate}>
                    <AddIcon fontSize="large" />
                  </Paper>
                </Grid>
              ) : null}
          </Grid>
        </Grid>
      </>
    ) : null;
  }

  previousPage=() => {
    if (this.state.page === 0) return;
    this.setState((prevState) => {
      return { page: prevState.page - 1 };
    });
    this.props.fetchTaskTemplatePages({ pageSize: this.state.pageSize, page: this.state.page - 1, block: this.state.block });
  }

  nextPage=(totalPages) => {
    if (this.state.page === totalPages - 1) return;
    this.setState((prevState) => {
      return { page: prevState.page + 1 };
    });
    this.props.fetchTaskTemplatePages({ pageSize: this.state.pageSize, page: this.state.page + 1, block: this.state.block });
  }

  changePage=(pagenum) => {
    if (this.state.page === pagenum) return;
    this.setState({ page: pagenum });
    this.props.fetchTaskTemplatePages({ pageSize: this.state.pageSize, page: pagenum, block: this.state.block });
  }

  enableFilter =() => {
    this.setState((prevState) => {
      return {
        block: '',
        filtered: !prevState.filtered,
      };
    });
  }

  handleSizeChange=(e) => {
    const value = e.target.value;
    this.setState({ pageSize: value });
    this.props.fetchTaskTemplatePages({ pageSize: value, page: this.state.page, block: this.state.block });
  }

  handlefilterChange=(e) => {
    const value = e.target.value;
    this.setState({ block: value });
    this.props.fetchTaskTemplatePages({ pageSize: PAGE_SIZE, page: PAGE, block: value });
  }

  render() {
    const { classes } = this.props;
    const totalPages = this.props.templates && this.props.templates.pages;
    const pages = new Array(totalPages).fill(null).map((v, i) => { return i; });
    return (
      <Drawer>
        <CssBaseline />
        <div className={classes.root}>
          <div className={classes.filters}>
            <div className={classes.filterdiv}>
              <Typography component="div">
                <Grid component="label" container alignItems="center" spacing={1}>
                  <Grid item>
                    <Typography variant="h6">All</Typography>
                  </Grid>
                  <Grid item>
                    <AntSwitch checked={this.state.filtered} onChange={this.enableFilter} name="filtered" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">Filtered</Typography>
                  </Grid>
                </Grid>
              </Typography>
              {this.state.filtered
                ? (
                  <div className={classes.innerdiv}>
                    <Typography variant="h6">Filter By:-</Typography>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="simple-select-blocktype-label">Block</InputLabel>
                      <Select
                        labelId="simple-select-blocktype-label"
                        id="simple-select-block"
                        value={this.state.block}
                        name="block"
                        onChange={this.handlefilterChange}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value="undefined">
                          <em>undefined</em>
                        </MenuItem>
                        {
                  Object.keys(BLOCK_TYPES).map((type) => { return (<MenuItem key={type} value={type}>{type}</MenuItem>); })
                       }
                      </Select>
                    </FormControl>
                  </div>
                ) : null}
            </div>
            <div className={classes.innerdiv}>
              <Typography variant="h6">No. of templates:-</Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="simple-select-blocktype-label">Page Size</InputLabel>
                <Select
                  labelId="simple-select-blocktype-label"
                  label="Page Size"
                  id="simple-select-block"
                  value={this.state.pageSize}
                  name="pageSize"
                  onChange={this.handleSizeChange}
                >
                  {
                    [8, 11, 17, 23].map((type) => { return (<MenuItem key={type} value={type}>{type}</MenuItem>); })
                  }
                </Select>
              </FormControl>
            </div>
            <div className={classes.innerdiv}>
              <Button variant="contained" color="primary" onClick={this.setAdding}>Create A new Template</Button>
            </div>
          </div>
          {this.props.fetching ? null : this.getallTemplatesUi()}
          <div className={classes.page_nav}>
            <ButtonGroup color="primary" aria-label="outlined primary button group">
              <Button onClick={this.previousPage}>Previous</Button>
              {pages && pages.map((pageidx) => {
                return (
                  <Button
                    variant={pageidx === this.state.page ? 'contained' : null}
                    key={pageidx}
                    onClick={() => { return this.changePage(pageidx); }}
                  >
                    {pageidx + 1}
                  </Button>
                );
              })}
              <Button onClick={() => { return this.nextPage(totalPages); }}>Next</Button>
            </ButtonGroup>
          </div>
        </div>
      </Drawer>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    templates: state.taskTemplate.page,
    fetching: state.taskTemplate.fetching,
    quizes: state.quizes.data,
    assessments: state.assessments.data,
    learnExercises: state.learnExercises.data,
    videoTypeExercises: state.videoExercises.videoTypes,
    videoUrlTypeExercises: state.videoExercises.videoUrlTypes,
    practiceExercises: state.practiceExercises.data,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TaskTemplates));
